export const PAGES = (type) => [
  {
    title: 'e_invoice',
    iconName: 'invoice',
    buttonName: 'generate',
    redirectUrl: 'invoice',
  },
  {
    title: 'invoice_list.debit',
    iconName: 'creditDebit',
    buttonName: 'generate',
    redirectUrl: 'debit',
  },
  {
    title: 'invoice_list.credit',
    iconName: 'creditDebit',
    buttonName: 'generate',
    redirectUrl: 'credit',
  },
];

export const ROUTES = (type) => [
  {
    label: 'generate-e-invoice',
    value: '',
  },
  {
    label: 'sme',
    link: 'additional-functionalities/sme',
  },
  {
    label: 'additional_functionalities',
    link: 'additional-functionalities',
  },
];
